module.exports = __webpack_public_path__ + "lato-medium-0996d39c4cf5d223a14559dfa37047fd.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/lato-medium/lato-medium.woff2
// module id = 1050
// module chunks = 0